function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { Route } from 'react-router-dom';
import { getWithTransaction } from './get-with-transaction';

function getApmRoute(apm) {
  var withTransaction = getWithTransaction(apm);
  return function ApmRoute(props) {
    var path = props.path,
        component = props.component;
    var apmComponent = withTransaction(path, 'route-change')(component);
    return React.createElement(Route, _extends({}, props, {
      component: apmComponent
    }));
  };
}

export { getApmRoute };